import { FC, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Form as FormAnt, Input, ModalProps, Typography, message } from "antd";
import { Modal } from '@hdi-seguros/web-components.modal';
import { ColSize, RowSize } from "../../../../../../shared/components";
import './index.css';


interface EndorsementsModalProps extends ModalProps {
    onClose?: () => void;
}

export const EndorsementsModal: FC<EndorsementsModalProps> = ({ open, title, onClose }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onPressCancell = () => {
        navigate('/home');
      }

    return (
        <Modal
            title={title}
            centered                
            open={open}
            width={650}
            footer
            closeIcon={false}
            onOk={onClose}
            confirmText={'Aceptar'}
            loadingConfirmButton={loading}
            onCancel={onPressCancell}
        >
            <>
                <RowSize
                    rowProps={{ gutter: [0, 0], justify: 'end', align: 'middle' }}
                >
                    <ColSize size={100}>
                        <Typography.Text>
                            Por favor, verifique que los valores actuales de Ascensores y Calderas sean los correctos para poder realizar el aumento de suma. <br />
                            En el caso de que la suma sugerida no sea la correcta, por favor solicite el endoso a través de la direccion de email
                            <b> tecnica@barbuss.com </b><br /> <br />
                            Muchas gracias.
                        </Typography.Text>
                    </ColSize>
                </RowSize>
            </>
        </Modal>
    )
}